import * as D from '../../data';

export const getLayerFillCountTwoPhase = (
  layerIndex: number,
  currentPhase: number,
  fillCount: number,
) => {
  const pairIndex = Math.floor(layerIndex / 2);
  const isBackgroundLayer = layerIndex % 2 === 0;
  const isCurrentPair = pairIndex === Math.floor(currentPhase / 2);

  if (isBackgroundLayer) {
    return pairIndex <= Math.floor(currentPhase / 2) ? D.TOTAL_PIXELS : 0;
  }

  if (isCurrentPair) {
    return fillCount;
  } else if (pairIndex < Math.floor(currentPhase / 2)) {
    return D.TOTAL_PIXELS;
  }

  return 0;
};

export const getUserContribution = (
  layerIndex: number,
  currentPhase: number,
  userContribution?: {
    startPixel: number;
    pixelCount: number;
  },
) => {
  if (!userContribution || !Number.isFinite(currentPhase)) {
    return null;
  }

  // background 레이어 건너뛰기
  if (layerIndex % 2 === 0) {
    return null;
  }

  const pixelsPerTree = D.TOTAL_PIXELS;

  const userTreeIndex = Math.floor(userContribution.startPixel / pixelsPerTree);

  const currentTreeIndex = Math.floor(layerIndex / 2);

  if (userTreeIndex !== currentTreeIndex) {
    return null;
  }

  return {
    startPixel: userContribution.startPixel % pixelsPerTree,
    pixelCount: userContribution.pixelCount,
  };
};

export const calculateProgressPercent = (
  currentPhase: number,
  totalContributionData: number,
) => {
  const maxContributionPerPhase = D.TOTAL_PIXELS * D.CONTRIBUTIONS_PER_PIXEL;
  const totalPhaseCompleted = Math.floor(
    totalContributionData / maxContributionPerPhase,
  );
  const remainingContribution = totalContributionData % maxContributionPerPhase;

  if (currentPhase === 1) {
    return Math.floor((remainingContribution / maxContributionPerPhase) * 100);
  }

  return (
    totalPhaseCompleted * 100 +
    Math.floor((remainingContribution / maxContributionPerPhase) * 100)
  );
};

export const getPhaseCountMessage = (currentPhase: number) => {
  if (currentPhase <= 1) {
    return '';
  }

  return `목표를 달성해 트리 ${Math.floor(
    currentPhase / 2,
  )}개가 완성되었어요!\n새로운 트리를 완성해보세요.`;
};
